import { useMutation } from "@tanstack/react-query";
import { toast } from "react-toastify";
import { Agendamento } from "../../../../services/Agendamento";

export const useRetornarStatusIniciadoAgendamento = () => {
  return useMutation({
    mutationFn: (data: { uuid: string }) =>
      Agendamento.retornarStatusIniciado(data),
    onError: ({
      response: {
        data: { mensagem },
      },
    }: any) => {
      toast.error(mensagem);
    },
  });
};
